export default {
  name: 'Legal Consent |||| Legal Consents',
  fields: {
    type: 'Type',
    version: 'Version',
    requestTitle: 'Request title',
    requestBody: 'Request body',
    url: 'URL',
    mandatory: 'Mandatory',
    validityType: 'Validity type',
    validityDuration: 'Validity duration',
    solutionId: 'Solution',
    status: 'Status',
    withDeleted: 'With archived',
    created: 'Created',
    addNew: 'Add legal consent',
    editConsent: 'Edit legal consent',
    INFINITE: 'Infinite',
    ONE_TIME: 'One-time',
    DURATION: 'Duration',
    noResultsFound: 'No legal consents found',
    searchInProgress: 'Loading...',
  },
};
